<template>
  <div>
    <h1>{{ $t('decodeWatermark.title') }}</h1>
    <div class="title">{{ $t('decodeWatermark.originalImage') }}</div>
    <el-upload
      :auto-upload="false"
      :on-change="handleChangeImageSuccess"
      :show-file-list="false"
      action=""
      class="avatar-uploader"
      drag
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>

    <div class="title">{{ $t('decodeWatermark.parameters') }}</div>

    <el-descriptions :column="1" border>
      <el-descriptions-item :label="$t('decodeWatermark.theme')">
        <el-radio-group v-model="theme" @change="handleChangeTheme">
          <el-radio-button :label="$t('decodeWatermark.light')" value="light"/>
          <el-radio-button :label="$t('decodeWatermark.dark')" value="dark"/>
        </el-radio-group>
      </el-descriptions-item>
      <el-descriptions-item :label="$t('decodeWatermark.compositeOperation')">
        <el-select v-model="compositeOperation" :placeholder="$t('decodeWatermark.pleaseInputCompositeOperation')"
                   filterable
                   style="width: 400px" @change="handleChangeCompositeOperation">
          <el-option v-for="item in compositeOperations" :key="item" :label="item" :value="item"/>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item :label="$t('decodeWatermark.compositeTimes')">
        <el-input-number v-model="compositeTimes" @change="handleChangeCompositeTimes"/>
      </el-descriptions-item>
      <el-descriptions-item :label="$t('decodeWatermark.fillColor')">
        <el-color-picker v-model="fillColor" @change="handleChangeFillColor"/>
      </el-descriptions-item>
    </el-descriptions>

    <div class="title">{{ $t('decodeWatermark.result') }}</div>
    <el-image
      :preview-src-list="[resultImageUrl]"
      :src="resultImageUrl"
      style="width: 400px; height: 400px">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline avatar-picture-outline-icon"></i>
      </div>
    </el-image>
  </div>
</template>

<script>
import {BlindWatermark} from 'watermark-js-plus';

export default {
  name: 'decodeWatermark',
  data() {
    return {
      imageUrl: '',
      theme: 'Light',
      compositeOperation: 'overlay',
      compositeTimes: 4,
      fillColor: '#000',
      resultImageUrl: '',
      resultImageUrl2: '',
      compositeOperations: [
        'source-over',
        'source-in',
        'source-out',
        'source-atop',
        'destination-over',
        'destination-in',
        'destination-out',
        'destination-atop',
        'lighter',
        'copy',
        'xor',
        'multiply',
        'screen',
        'overlay',
        'darken',
        'lighten',
        'color-dodge',
        'color-burn',
        'hard-light',
        'soft-light',
        'difference',
        'exclusion',
        'hue',
        'saturation',
        'color',
        'luminosity',
      ],
    };
  },

  methods: {
    handleChangeImageSuccess(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.handleDecode();
    },
    handleChangeTheme(theme) {
      this.compositeOperation = 'overlay';
      if (theme === 'Light') {
        this.fillColor = '#000000';
        this.compositeTimes = 4;
      } else {
        this.fillColor = '#ffffff';
        this.compositeTimes = 2;
      }
      this.handleDecode();
    },
    handleChangeCompositeOperation() {
      this.handleDecode();
    },
    handleChangeCompositeTimes() {
      this.handleDecode();
    },
    handleChangeFillColor() {
      this.handleDecode();
    },
    handleDecode() {
      BlindWatermark.decode({
        fillColor: this.fillColor,
        compositeTimes: this.compositeTimes,
        compositeOperation: this.compositeOperation,
        url: this.imageUrl,
        onSuccess: (imageBase64) => {
          this.resultImageUrl = imageBase64;
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  width: 100%;
  display: flex;
  justify-content: center;

  .white {
    width: 400px;
    height: 400px;
    background-color: #fff;
    color: #000;
    text-align: center;
    align-items: center;
  }

  .black {
    width: 400px;
    height: 400px;
    background-color: #000;
    color: #fff;
    text-align: center;
    align-items: center;
  }

  .red {
    width: 400px;
    height: 400px;
    background-color: red;
    color: #000;
    text-align: center;
    align-items: center;
  }

  .green {
    width: 400px;
    height: 400px;
    background-color: green;
    color: #fff;
    text-align: center;
    align-items: center;
  }

  .gray {
    width: 400px;
    height: 400px;
    background-color: gray;
    color: #fff;
    text-align: center;
    align-items: center;
  }
}


.title {
  color: var(--el-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}

::v-deep .el-upload-dragger {
  width: auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar-picture-outline-icon {
  font-size: 50px;
  color: #8c939d;
  width: 400px;
  height: 400px;
  line-height: 400px;
  text-align: center;
  background: #FFFFFF;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.image-slot {
  width: 178px;
  height: 178px;
}

</style>
